import { GTMFriendReaction } from '../../../../../constants/analytics/GTM';
import Icon from '../../../../baseComponents/gui/icon/Icon';
import { CustomButton } from '../../../../features/customButton';
import CustomBridge from '../../../../../controllers/bridge/CustomBridge';
import React from 'react';
import useSetReaction from '../../model/hooks/useSetReaction';
import content from '../../constants/content';
import { useUser } from '../../../../../redux/reducer/user';
import { useCountsData } from '../../../../../hooks/useCountsData';
import { useContent } from '../../../../../redux/reducer/content';

const { buttons } = content;

export default function Actions() {
  const { profile } = useUser();
  const { viewedFriend } = useContent();

  const setReaction = useSetReaction();
  const counts = useCountsData(viewedFriend);

  return (
    <div className={'share__actions'}>
      <div className={'share__counts'}>
        {!!profile &&
          counts?.map(({ icon, index, clickData }, i) => (
            <div key={i} className={'share__count-item'} onClick={() => setReaction(clickData)}>
              <Icon name={icon} />
              <span>{index}</span>
            </div>
          ))}
      </div>

      {!profile && (
        <CustomButton {...buttons.auth} onClick={() => CustomBridge.instance.send({ name: 'AUTH', type: 0 })} />
      )}
    </div>
  );
}
